<template>
  <div class="view-community">
    <action-dispatcher
      action="community/get"
      :parameters="$route.params.id"
      ref="dispatcher"
    >
      <div class="community-header">
        <div
          v-if="community && community.cover"
          class="community-cover"
          :style="coverStyle"
        />
        <div class="container-fluid">
          <div class="header-content d-flex align-items-center">
            <button class="btn btn-back p-0 mr-3" @click="goBack">
              <i class="icon-chevron-left" />
            </button>
            <div class="flex-fill">
              <h4 class="community-name mb-0">{{ communityName }}</h4>
              <p
                v-if="community && community.description"
                class="community-description mb-0"
              >
                {{ community.description }}
              </p>
            </div>
            <community-bell :community-id="$route.params.id" />
          </div>
        </div>
      </div>

      <div class="container-fluid community-body">
        <b-tabs class="community-tabs" content-class="mt-4">
          <b-tab title="Feed" active>
            <post-composer
              v-if="canModerate"
              :community-id="$route.params.id"
              :can-moderate="canModerate"
              class="mb-4"
              @created="onPostCreated"
            />
            <community-feed
              ref="feed"
              :community-id="$route.params.id"
              :can-moderate="canModerate"
            />
          </b-tab>
          <b-tab title="Fóruns" lazy>
            <forum-list :community-id="$route.params.id" />
          </b-tab>
        </b-tabs>
      </div>
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PostComposer from "@/components/community/PostComposer.vue";
import CommunityFeed from "@/components/community/CommunityFeed.vue";
import CommunityBell from "@/components/community/CommunityBell.vue";
import ForumList from "@/components/community/ForumList.vue";

export default {
  name: "CommunityView",
  components: { PostComposer, CommunityFeed, CommunityBell, ForumList },
  computed: {
    ...mapState("community", ["community"]),
    canModerate() {
      return !!(this.community && this.community.can_moderate);
    },
    communityName() {
      return this.community ? this.community.name : "";
    },
    coverStyle() {
      return {
        backgroundImage:
          this.community && this.community.cover
            ? `url(${this.community.cover})`
            : ""
      };
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "home" });
    },
    onPostCreated() {
      if (this.$refs.feed) this.$refs.feed.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-community {
  padding-top: 72px;
  padding-bottom: 40px;

  .community-header {
    margin-bottom: 24px;

    .community-cover {
      height: 160px;
      border-radius: 12px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      margin-bottom: 16px;
    }

    .btn-back {
      border: none;
      background: transparent;
      color: inherit;

      i {
        font-size: 22px;
      }
    }

    .community-name {
      font-size: 20px;
      font-weight: 600;
    }

    .community-description {
      font-size: 14px;
      opacity: 0.75;
    }
  }

  .community-tabs {
    ::v-deep .nav-tabs {
      border-bottom: 1px solid rgba(128, 128, 128, 0.2);

      .nav-link {
        border: none;
        background: transparent;
        color: inherit;
        opacity: 0.6;
        font-weight: 500;
        padding: 8px 16px;

        &.active {
          opacity: 1;
          border-bottom: 2px solid currentColor;
        }
      }
    }
  }
}
</style>
